// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__Ra14z","inner":"faq_inner__3z7KH","items":"faq_items__2Hfd5"};